var _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _path, _polygon6, _polygon7, _polygon8, _path2, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _polygon37, _polygon38, _polygon39, _polygon40, _polygon41, _polygon42, _polygon43, _polygon44, _polygon45, _g, _polygon46, _polygon47, _polygon48, _polygon49, _polygon50, _polygon51, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContainer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 50 50",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A53636",
    points: "49.193 30.388 49.188 31.716 18.996 49.262 19 47.934"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#B4403C",
    points: "19 47.934 18.996 49.262 .78 38.746 .785 37.417"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#F17572",
    points: "49.193 30.388 19 47.934 .785 37.417 30.977 19.871"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#CB4844",
    points: "19.85 47.523 19.854 48.611 20.004 48.698 20.001 47.61"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#B4403C",
    points: "20.001 47.61 20.004 48.698 21.078 48.078 21.074 46.99"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#40545D",
    d: "M20.5384,47.54807c-0.15245,0.08802-0.27536,0.3008-0.27487,0.47607 c0.0005,0.17513,0.12421,0.24567,0.27666,0.15765c0.15246-0.08802,0.27536-0.30094,0.27487-0.47607 C20.81457,47.53044,20.69086,47.46005,20.5384,47.54807z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#F17572",
    points: "19.85 47.523 20.001 47.61 21.074 46.99 20.924 46.903"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#CB4844",
    points: "47.992 31.189 47.995 32.277 48.146 32.364 48.142 31.276"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#B4403C",
    points: "48.142 31.276 48.146 32.364 49.22 31.744 49.216 30.656"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#40545D",
    d: "M48.68015,31.21408c-0.15246,0.08802-0.27536,0.3008-0.27487,0.47607 c0.0005,0.17513,0.12421,0.24566,0.27666,0.15764c0.15245-0.08802,0.27536-0.30094,0.27486-0.47607 C48.95631,31.19646,48.8326,31.12606,48.68015,31.21408z"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#F17572",
    points: "47.992 31.189 48.142 31.276 49.216 30.656 49.066 30.569"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#CB4844",
    points: "46.598 13.017 46.651 31.5 48.341 30.524 48.288 12.041"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#B4403C",
    points: "45.983 13.096 46.035 31.579 46.651 31.5 46.598 13.017"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A53636",
    points: "45.844 13.452 45.897 31.935 46.035 31.579 45.983 13.096"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#CB4844",
    points: "44.145 14.434 44.197 32.917 45.897 31.935 45.844 13.452"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#B4403C",
    points: "43.529 14.513 43.581 32.995 44.197 32.917 44.145 14.434"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A53636",
    points: "43.391 14.869 43.443 33.352 43.581 32.995 43.529 14.513"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#CB4844",
    points: "41.691 15.851 41.743 34.333 43.443 33.352 43.391 14.869"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#B4403C",
    points: "41.074 15.93 41.126 34.413 41.743 34.333 41.691 15.851"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A53636",
    points: "40.937 16.286 40.989 34.769 41.126 34.413 41.074 15.93"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#CB4844",
    points: "39.237 17.267 39.289 35.75 40.989 34.769 40.937 16.286"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#B4403C",
    points: "38.622 17.347 38.674 35.83 39.289 35.75 39.237 17.267"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A53636",
    points: "38.484 17.702 38.536 36.185 38.674 35.83 38.622 17.347"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#CB4844",
    points: "36.783 18.684 36.835 37.167 38.536 36.185 38.484 17.702"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#B4403C",
    points: "36.168 18.764 36.22 37.246 36.835 37.167 36.783 18.684"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A53636",
    points: "36.03 19.119 36.082 37.602 36.22 37.246 36.168 18.764"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#CB4844",
    points: "34.33 20.1 34.382 38.583 36.082 37.602 36.03 19.119"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#B4403C",
    points: "33.713 20.18 33.765 38.663 34.382 38.583 34.33 20.1"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A53636",
    points: "33.576 20.536 33.628 39.018 33.765 38.663 33.713 20.18"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#CB4844",
    points: "31.876 21.517 31.928 40 33.628 39.018 33.576 20.536"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#B4403C",
    points: "31.259 21.597 31.312 40.079 31.928 40 31.876 21.517"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A53636",
    points: "31.121 21.953 31.173 40.436 31.312 40.079 31.259 21.597"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#CB4844",
    points: "29.422 22.934 29.474 41.417 31.173 40.436 31.121 21.953"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#B4403C",
    points: "28.805 23.013 28.858 41.496 29.474 41.417 29.422 22.934"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A53636",
    points: "28.667 23.37 28.719 41.852 28.858 41.496 28.805 23.013"
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#CB4844",
    points: "26.968 24.351 27.02 42.833 28.719 41.852 28.667 23.37"
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#B4403C",
    points: "26.353 24.43 26.406 42.913 27.02 42.833 26.968 24.351"
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A53636",
    points: "26.214 24.786 26.266 43.269 26.406 42.913 26.353 24.43"
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#CB4844",
    points: "24.514 25.768 24.566 44.25 26.266 43.269 26.214 24.786"
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#B4403C",
    points: "23.899 25.847 23.952 44.33 24.566 44.25 24.514 25.768"
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A53636",
    points: "23.76 26.203 23.812 44.685 23.952 44.33 23.899 25.847"
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#CB4844",
    points: "22.061 27.184 22.113 45.666 23.812 44.685 23.76 26.203"
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#B4403C",
    points: "21.444 27.263 21.497 45.746 22.113 45.666 22.061 27.184"
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A53636",
    points: "21.306 27.62 21.359 46.102 21.497 45.746 21.444 27.263"
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#B4403C",
    points: "19.549 28.556 19.602 47.039 19.669 47.078 19.616 28.595"
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#CB4844",
    points: "21.365 27.217 21.22 27.592 19.549 28.556 19.616 28.595 21.306 27.62 21.444 27.263 22.061 27.184 23.76 26.203 23.899 25.847 24.514 25.768 26.214 24.786 26.353 24.43 26.968 24.351 28.667 23.37 28.805 23.013 29.422 22.934 31.121 21.953 31.259 21.597 31.876 21.517 33.576 20.536 33.713 20.18 34.33 20.1 36.03 19.119 36.168 18.764 36.783 18.684 38.484 17.702 38.622 17.347 39.237 17.267 40.937 16.286 41.074 15.93 41.691 15.851 43.391 14.869 43.529 14.513 44.145 14.434 45.844 13.452 45.983 13.096 46.598 13.017 48.288 12.041 48.221 12.003 46.552 12.967 45.904 13.05 45.757 13.425 44.098 14.383 43.45 14.467 43.304 14.842 41.644 15.8 40.995 15.884 40.85 16.259 39.19 17.217 38.543 17.301 38.397 17.675 36.736 18.634 36.089 18.718 35.943 19.092 34.283 20.05 33.634 20.134 33.489 20.508 31.828 21.467 31.18 21.551 31.035 21.925 29.374 22.884 28.726 22.968 28.581 23.342 26.92 24.301 26.274 24.384 26.128 24.758 24.466 25.718 23.82 25.801 23.674 26.175 22.013 27.134"
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#CB4844",
    points: "19.616 28.595 19.669 47.078 21.359 46.102 21.306 27.62"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#CB4844",
    points: "29.379 3.106 29.431 21.589 31.121 20.613 31.068 2.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#B4403C",
    points: "28.763 3.185 28.815 21.668 29.431 21.589 29.379 3.106"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#A53636",
    points: "28.625 3.541 28.677 22.024 28.815 21.668 28.763 3.185"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#CB4844",
    points: "26.925 4.523 26.977 23.005 28.677 22.024 28.625 3.541"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#B4403C",
    points: "26.309 4.602 26.361 23.084 26.977 23.005 26.925 4.523"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#A53636",
    points: "26.171 4.958 26.223 23.441 26.361 23.084 26.309 4.602"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#CB4844",
    points: "24.471 5.94 24.523 24.422 26.223 23.441 26.171 4.958"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#B4403C",
    points: "23.854 6.019 23.906 24.502 24.523 24.422 24.471 5.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#A53636",
    points: "23.717 6.375 23.769 24.858 23.906 24.502 23.854 6.019"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#CB4844",
    points: "22.017 7.356 22.069 25.839 23.769 24.858 23.717 6.375"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#B4403C",
    points: "21.402 7.436 21.454 25.919 22.069 25.839 22.017 7.356"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#A53636",
    points: "21.264 7.791 21.316 26.274 21.454 25.919 21.402 7.436"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#CB4844",
    points: "19.563 8.773 19.615 27.256 21.316 26.274 21.264 7.791"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#B4403C",
    points: "18.948 8.853 19 27.335 19.615 27.256 19.563 8.773"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#A53636",
    points: "18.81 9.208 18.862 27.691 19 27.335 18.948 8.853"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#CB4844",
    points: "17.11 10.189 17.162 28.672 18.862 27.691 18.81 9.208"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#B4403C",
    points: "16.493 10.269 16.546 28.751 17.162 28.672 17.11 10.189"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#A53636",
    points: "16.356 10.625 16.408 29.107 16.546 28.751 16.493 10.269"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#CB4844",
    points: "14.656 11.606 14.708 30.089 16.408 29.107 16.356 10.625"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#B4403C",
    points: "14.039 11.686 14.092 30.168 14.708 30.089 14.656 11.606"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#A53636",
    points: "13.901 12.042 13.953 30.525 14.092 30.168 14.039 11.686"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#CB4844",
    points: "12.202 13.023 12.254 31.506 13.953 30.525 13.901 12.042"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#B4403C",
    points: "11.585 13.102 11.638 31.585 12.254 31.506 12.202 13.023"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#A53636",
    points: "11.447 13.459 11.499 31.941 11.638 31.585 11.585 13.102"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#CB4844",
    points: "9.748 14.44 9.8 32.922 11.499 31.941 11.447 13.459"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#B4403C",
    points: "9.133 14.519 9.186 33.002 9.8 32.922 9.748 14.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#A53636",
    points: "8.994 14.875 9.046 33.358 9.186 33.002 9.133 14.519"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#CB4844",
    points: "7.294 15.856 7.347 34.339 9.046 33.358 8.994 14.875"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#B4403C",
    points: "6.679 15.936 6.732 34.419 7.347 34.339 7.294 15.856"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#A53636",
    points: "6.54 16.292 6.593 34.774 6.732 34.419 6.679 15.936"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#CB4844",
    points: "4.841 17.273 4.894 35.755 6.593 34.774 6.54 16.292"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#B4403C",
    points: "4.224 17.352 4.277 35.835 4.894 35.755 4.841 17.273"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#A53636",
    points: "4.086 17.709 4.139 36.191 4.277 35.835 4.224 17.352"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#B4403C",
    points: "2.329 18.645 2.382 37.128 2.449 37.167 2.396 18.684"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#CB4844",
    points: "4.146 17.306 4 17.681 2.329 18.645 2.396 18.684 4.086 17.709 4.224 17.352 4.841 17.273 6.54 16.292 6.679 15.936 7.294 15.856 8.994 14.875 9.133 14.519 9.748 14.44 11.447 13.459 11.585 13.102 12.202 13.023 13.901 12.042 14.039 11.686 14.656 11.606 16.356 10.625 16.493 10.269 17.11 10.189 18.81 9.208 18.948 8.853 19.563 8.773 21.264 7.791 21.402 7.436 22.017 7.356 23.717 6.375 23.854 6.019 24.471 5.94 26.171 4.958 26.309 4.602 26.925 4.523 28.625 3.541 28.763 3.185 29.379 3.106 31.068 2.13 31.002 2.091 29.332 3.055 28.684 3.139 28.538 3.514 26.878 4.472 26.23 4.556 26.084 4.931 24.424 5.889 23.775 5.973 23.63 6.348 21.97 7.306 21.323 7.39 21.177 7.764 19.516 8.723 18.869 8.807 18.723 9.181 17.063 10.139 16.414 10.223 16.269 10.597 14.608 11.556 13.96 11.64 13.815 12.014 12.154 12.973 11.506 13.057 11.361 13.431 9.7 14.39 9.054 14.473 8.908 14.847 7.246 15.807 6.601 15.89 6.454 16.264 4.793 17.223"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#CB4844",
    points: "2.396 18.684 2.449 37.167 4.139 36.191 4.086 17.709"
  }))), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#EE5550",
    points: "19.549 29.865 19.602 47.076 2.367 37.126 2.329 19.922"
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#B4403C",
    points: "10.965 24.909 11.018 42.083 10.729 41.917 10.69 24.75"
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#DDE4E7",
    points: "19.549 31.016 19.541 33.869 18.714 32.956 18.72 31.305"
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#DDE4E7",
    points: "19.549 42.824 19.541 45.677 18.714 44.763 18.72 43.113"
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#DDE4E7",
    points: "2.329 21.546 2.338 24.371 3.116 24.672 3.11 23.037"
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#DDE4E7",
    points: "2.335 33.187 2.344 36.011 3.123 36.313 3.117 34.678"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#B4403C",
    points: "17.897 31.297 18.151 31.149 18.149 32.07 17.895 32.218"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F17572",
    points: "11.676 27.705 11.93 27.558 18.151 31.149 17.897 31.297"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#CB4844",
    points: "17.897 31.297 17.895 32.218 11.673 28.626 11.676 27.705"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#B4403C",
    points: "17.897 35.328 18.151 35.181 18.149 36.101 17.895 36.249"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F17572",
    points: "11.676 31.737 11.93 31.589 18.151 35.181 17.897 35.328"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#CB4844",
    points: "17.897 35.328 17.895 36.249 11.673 32.657 11.676 31.737"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#B4403C",
    points: "17.897 39.36 18.151 39.212 18.149 40.133 17.895 40.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F17572",
    points: "11.676 35.768 11.93 35.62 18.151 39.212 17.897 39.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#CB4844",
    points: "17.897 39.36 17.895 40.28 11.673 36.689 11.676 35.768"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#B4403C",
    points: "17.897 43.391 18.151 43.243 18.149 44.164 17.895 44.312"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F17572",
    points: "11.676 39.799 11.93 39.651 18.151 43.243 17.897 43.391"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#CB4844",
    points: "17.897 43.391 17.895 44.312 11.673 40.72 11.676 39.799"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#B4403C",
    points: "9.717 26.868 9.971 26.72 9.968 27.641 9.714 27.789"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F17572",
    points: "3.495 23.276 3.75 23.129 9.971 26.72 9.717 26.868"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#CB4844",
    points: "9.717 26.868 9.714 27.789 3.493 24.197 3.495 23.276"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#B4403C",
    points: "9.717 30.899 9.971 30.752 9.968 31.672 9.714 31.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F17572",
    points: "3.495 27.307 3.75 27.16 9.971 30.752 9.717 30.899"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#CB4844",
    points: "9.717 30.899 9.714 31.82 3.493 28.228 3.495 27.307"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#B4403C",
    points: "9.717 34.931 9.971 34.783 9.968 35.704 9.714 35.851"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F17572",
    points: "3.495 31.339 3.75 31.191 9.971 34.783 9.717 34.931"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#CB4844",
    points: "9.717 34.931 9.714 35.851 3.493 32.259 3.495 31.339"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#B4403C",
    points: "9.717 38.962 9.971 38.814 9.968 39.735 9.714 39.883"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F17572",
    points: "3.495 35.37 3.75 35.222 9.971 38.814 9.717 38.962"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#CB4844",
    points: "9.717 38.962 9.714 39.883 3.493 36.291 3.495 35.37"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#A53636",
    points: "49.193 11.456 49.188 12.785 18.996 30.331 19 29.002"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#B4403C",
    points: "19 29.002 18.996 30.331 .78 19.814 .785 18.486"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F17572",
    points: "49.193 11.456 19 29.002 .785 18.486 30.977 .94"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#A53636",
    points: "2.013 19.249 2.009 20.338 1.859 20.425 1.862 19.337"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#CB4844",
    points: "1.862 19.337 1.859 20.425 .785 19.805 .788 18.717"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#40545D",
    d: "M1.32447,19.27475c0.15246,0.08802,0.27536,0.3008,0.27487,0.47607 c-0.0005,0.17513-0.12421,0.24566-0.27666,0.15764s-0.27536-0.30094-0.27487-0.47607 C1.04831,19.25713,1.17202,19.18673,1.32447,19.27475z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F17572",
    points: "2.013 19.249 1.862 19.337 .788 18.717 .939 18.629"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#CB4844",
    points: "19.172 28.996 19.176 30.084 19.326 30.171 19.323 29.083"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#B4403C",
    points: "19.323 29.083 19.326 30.171 20.4 29.551 20.397 28.463"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#40545D",
    d: "M19.86055,29.02118c-0.15246,0.08802-0.27536,0.3008-0.27487,0.47607 c0.0005,0.17513,0.12421,0.24566,0.27666,0.15764c0.15245-0.08802,0.27536-0.30094,0.27487-0.47607 C20.13672,29.00355,20.01301,28.93316,19.86055,29.02118z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F17572",
    points: "19.172 28.996 19.323 29.083 20.397 28.463 20.246 28.376"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#CB4844",
    points: "47.992 12.268 47.995 13.356 48.146 13.444 48.142 12.355"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#B4403C",
    points: "48.142 12.355 48.146 13.444 49.22 12.824 49.216 11.735"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#40545D",
    d: "M48.68015,12.29327c-0.15246,0.08802-0.27536,0.3008-0.27487,0.47607 c0.0005,0.17513,0.12421,0.24567,0.27666,0.15765c0.15245-0.08802,0.27536-0.30094,0.27486-0.47607 C48.95631,12.27565,48.8326,12.20525,48.68015,12.29327z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F17572",
    points: "47.992 12.268 48.142 12.355 49.216 11.735 49.066 11.648"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#A53636",
    points: "20.253 28.09 20.249 28.292 19.004 29.015 19.008 28.813"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#B4403C",
    points: "19.008 28.813 19.004 29.015 17.752 28.292 17.756 28.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#CB4844",
    points: "20.253 28.09 19.008 28.813 17.756 28.09 19 27.366"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#A53636",
    points: "3.287 18.289 3.282 18.491 2.038 19.214 2.042 19.012"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#B4403C",
    points: "2.042 19.012 2.038 19.214 .785 18.491 .789 18.289"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#CB4844",
    points: "3.287 18.289 2.042 19.012 .789 18.289 2.034 17.565"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#A53636",
    points: "32.233 1.461 32.229 1.663 30.984 2.386 30.988 2.184"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#B4403C",
    points: "30.988 2.184 30.984 2.386 29.731 1.663 29.736 1.461"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#CB4844",
    points: "32.233 1.461 30.988 2.184 29.736 1.461 30.98 .738"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#A53636",
    points: "49.195 11.26 49.191 11.462 47.946 12.186 47.95 11.984"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#B4403C",
    points: "47.95 11.984 47.946 12.186 46.693 11.462 46.697 11.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#CB4844",
    points: "49.195 11.26 47.95 11.984 46.697 11.26 47.942 10.537"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#CB4844",
    points: "18.678 29.102 18.675 30.191 17.601 29.571 17.604 28.482",
    enableBackground: "new"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#A53636",
    points: "18.829 29.015 18.825 30.103 18.675 30.191 18.678 29.102"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F17572",
    points: "18.829 29.015 18.678 29.102 17.604 28.482 17.755 28.395"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#40545D",
    d: "M18.14036,29.04028c0.15246,0.08802,0.27536,0.3008,0.27487,0.47607 c-0.0005,0.17513-0.12421,0.24566-0.27666,0.15764c-0.15246-0.08802-0.27536-0.30094-0.27487-0.47607 C17.8642,29.02266,17.98791,28.95226,18.14036,29.04028z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#A53636",
    points: "18.829 47.946 18.825 49.034 18.675 49.122 18.678 48.034"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#CB4844",
    points: "18.678 48.034 18.675 49.122 17.601 48.502 17.604 47.414"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#40545D",
    d: "M18.14036,47.97171c0.15246,0.08802,0.27536,0.3008,0.27487,0.47607 c-0.0005,0.17513-0.12421,0.24567-0.27666,0.15765c-0.15246-0.08802-0.27536-0.30094-0.27487-0.47607 C17.8642,47.95408,17.98791,47.88369,18.14036,47.97171z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F17572",
    points: "18.829 47.946 18.678 48.034 17.604 47.414 17.755 47.326"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#A53636",
    points: "2.013 38.181 2.009 39.269 1.859 39.356 1.862 38.268"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#CB4844",
    points: "1.862 38.268 1.859 39.356 .785 38.736 .788 37.648"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#40545D",
    d: "M1.32447,38.20618c0.15246,0.08802,0.27536,0.3008,0.27487,0.47607 c-0.0005,0.17513-0.12421,0.24567-0.27666,0.15765s-0.27536-0.30094-0.27487-0.47607 C1.04831,38.18855,1.17202,38.11816,1.32447,38.20618z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F17572",
    points: "2.013 38.181 1.862 38.268 .788 37.648 .939 37.561"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B0B8BC",
    d: "M5.64988,39.19638L5.6481,39.31065c-0.00019,0.06807-0.04495,0.13603-0.13435,0.18799 c-0.17996,0.10458-0.47247,0.10458-0.65361,0c-0.09115-0.05262-0.13668-0.12167-0.13648-0.19062l0.00178-0.11427 c-0.00019,0.06894,0.04533,0.13799,0.13648,0.19062c0.18113,0.10458,0.47365,0.10458,0.65361,0 C5.60493,39.33241,5.64969,39.26445,5.64988,39.19638z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DDE4E7",
    d: "M5.51341,39.00576c0.18113,0.10458,0.18208,0.27402,0.00212,0.3786 c-0.17996,0.10458-0.47248,0.10458-0.65361,0c-0.18113-0.10458-0.1821-0.27401-0.00214-0.37859 C5.03974,38.90119,5.33228,38.90118,5.51341,39.00576z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFD8DD",
    d: "M5.38715,22.01649L5.38638,39.13633c-0.00008,0.02945-0.01945,0.05886-0.05813,0.08134 c-0.07786,0.04525-0.20443,0.04525-0.28281,0c-0.03944-0.02277-0.05914-0.05265-0.05905-0.08248l0.00077-17.11984 c-0.00008,0.02983,0.01961,0.05971,0.05905,0.08248c0.07837,0.04525,0.20494,0.04525,0.28281,0 C5.3677,22.07535,5.38707,22.04594,5.38715,22.01649z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DDE4E7",
    d: "M5.3281,21.93401c0.07837,0.04525,0.07878,0.11857,0.00092,0.16382 c-0.07787,0.04525-0.20443,0.04525-0.28281,0c-0.07837-0.04525-0.07879-0.11856-0.00093-0.16381 S5.24973,21.88876,5.3281,21.93401z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B0B8BC",
    d: "M5.64988,21.96009L5.6481,22.07437c-0.00019,0.06807-0.04495,0.13603-0.13435,0.18799 c-0.17996,0.10458-0.47247,0.10458-0.65361,0c-0.09115-0.05262-0.13668-0.12168-0.13648-0.19062l0.00178-0.11427 c-0.00019,0.06894,0.04533,0.13799,0.13648,0.19062c0.18113,0.10458,0.47365,0.10458,0.65361,0 C5.60493,22.09613,5.64969,22.02816,5.64988,21.96009z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DDE4E7",
    d: "M5.51341,21.76948c0.18113,0.10458,0.18208,0.27402,0.00212,0.3786 c-0.17996,0.10458-0.47248,0.10457-0.65361,0c-0.18113-0.10458-0.1821-0.27401-0.00214-0.37859 C5.03974,21.66491,5.33228,21.6649,5.51341,21.76948z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B0B8BC",
    d: "M8.35661,40.75909l-0.00178,0.11427c-0.00019,0.06807-0.04495,0.13603-0.13435,0.18799 c-0.17996,0.10458-0.47247,0.10458-0.65361,0c-0.09115-0.05262-0.13668-0.12167-0.13648-0.19062l0.00178-0.11427 c-0.00019,0.06894,0.04533,0.13799,0.13648,0.19062c0.18113,0.10458,0.47365,0.10458,0.65361,0 C8.31167,40.89512,8.35642,40.82716,8.35661,40.75909z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DDE4E7",
    d: "M8.22014,40.56847c0.18113,0.10458,0.18208,0.27402,0.00212,0.3786s-0.47248,0.10458-0.65361,0 c-0.18113-0.10458-0.1821-0.27401-0.00214-0.37859C7.74648,40.4639,8.03901,40.46389,8.22014,40.56847z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFD8DD",
    d: "M8.09389,23.5792L8.09312,40.69904c-0.00008,0.02945-0.01945,0.05886-0.05813,0.08134 c-0.07786,0.04525-0.20443,0.04525-0.28281,0c-0.03944-0.02277-0.05914-0.05265-0.05905-0.08248L7.6939,23.57806 c-0.00008,0.02983,0.01961,0.05971,0.05905,0.08248c0.07837,0.04525,0.20494,0.04525,0.28281,0 C8.07444,23.63806,8.0938,23.60865,8.09389,23.5792z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DDE4E7",
    d: "M8.03484,23.49672c0.07837,0.04525,0.07878,0.11857,0.00092,0.16382 c-0.07787,0.04525-0.20443,0.04525-0.28281,0c-0.07837-0.04525-0.07879-0.11856-0.00093-0.16381 S7.95646,23.45147,8.03484,23.49672z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B0B8BC",
    d: "M8.35661,23.5228l-0.00178,0.11427c-0.00019,0.06807-0.04495,0.13603-0.13435,0.18799 c-0.17996,0.10458-0.47247,0.10458-0.65361,0c-0.09115-0.05263-0.13668-0.12168-0.13648-0.19062l0.00178-0.11427 c-0.00019,0.06894,0.04533,0.13799,0.13648,0.19062c0.18113,0.10458,0.47365,0.10458,0.65361,0 C8.31167,23.65884,8.35642,23.59087,8.35661,23.5228z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DDE4E7",
    d: "M8.22014,23.33219c0.18113,0.10458,0.18208,0.27402,0.00212,0.3786s-0.47248,0.10458-0.65361,0 c-0.18113-0.10458-0.1821-0.27401-0.00214-0.37859C7.74648,23.22762,8.03901,23.22761,8.22014,23.33219z"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B0B8BC",
    d: "M13.37844,43.74634l-0.00178,0.11427c-0.00019,0.06807-0.04495,0.13603-0.13435,0.18799 c-0.17996,0.10458-0.47248,0.10457-0.65361,0c-0.09115-0.05262-0.13668-0.12167-0.13648-0.19062l0.00178-0.11427 c-0.00019,0.06895,0.04533,0.138,0.13648,0.19062c0.18113,0.10458,0.47365,0.10458,0.65361,0 C13.33349,43.88237,13.37825,43.81441,13.37844,43.74634z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DDE4E7",
    d: "M13.24197,43.55573c0.18113,0.10458,0.18208,0.27402,0.00212,0.3786 c-0.17996,0.10458-0.47248,0.10458-0.65361,0c-0.18113-0.10458-0.1821-0.27402-0.00214-0.3786 C12.7683,43.45116,13.06084,43.45115,13.24197,43.55573z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFD8DD",
    d: "M13.11571,26.56645l-0.00077,17.11984c-0.00008,0.02945-0.01945,0.05886-0.05813,0.08134 c-0.07786,0.04525-0.20443,0.04525-0.28281,0c-0.03944-0.02277-0.05914-0.05265-0.05905-0.08248l0.00077-17.11984 c-0.00008,0.02983,0.01961,0.05971,0.05905,0.08248c0.07837,0.04525,0.20494,0.04525,0.28281,0 C13.09626,26.62531,13.11563,26.5959,13.11571,26.56645z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DDE4E7",
    d: "M13.05666,26.48397c0.07837,0.04525,0.07878,0.11857,0.00092,0.16382s-0.20443,0.04525-0.28281,0 c-0.07837-0.04525-0.07879-0.11856-0.00093-0.16381C12.85172,26.43873,12.97829,26.43872,13.05666,26.48397z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B0B8BC",
    d: "M13.37844,26.51006l-0.00178,0.11427c-0.00019,0.06807-0.04495,0.13603-0.13435,0.18799 c-0.17996,0.10458-0.47248,0.10457-0.65361,0c-0.09115-0.05263-0.13668-0.12168-0.13648-0.19062l0.00178-0.11427 c-0.00019,0.06894,0.04533,0.13799,0.13648,0.19062c0.18113,0.10458,0.47365,0.10458,0.65361,0 C13.33349,26.64609,13.37825,26.57813,13.37844,26.51006z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DDE4E7",
    d: "M13.24197,26.31944c0.18113,0.10458,0.18208,0.27402,0.00212,0.3786 c-0.17996,0.10458-0.47248,0.10458-0.65361,0c-0.18113-0.10458-0.1821-0.27402-0.00214-0.37859 C12.7683,26.21487,13.06084,26.21486,13.24197,26.31944z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B0B8BC",
    d: "M16.08517,45.25317l-0.00178,0.11427c-0.00019,0.06807-0.04495,0.13603-0.13435,0.18799 c-0.17996,0.10458-0.47248,0.10457-0.65361,0c-0.09115-0.05262-0.13667-0.12167-0.13648-0.19062l0.00178-0.11427 c-0.00019,0.06894,0.04533,0.13799,0.13648,0.19062c0.18113,0.10458,0.47365,0.10458,0.65361,0 C16.04023,45.3892,16.08498,45.32124,16.08517,45.25317z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DDE4E7",
    d: "M15.9487,45.06255c0.18113,0.10458,0.18208,0.27402,0.00212,0.3786 c-0.17996,0.10458-0.47248,0.10458-0.65361,0c-0.18113-0.10458-0.1821-0.27401-0.00214-0.37859 C15.47504,44.95798,15.76757,44.95797,15.9487,45.06255z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFD8DD",
    d: "M15.82245,28.07327l-0.00077,17.11984c-0.00008,0.02945-0.01945,0.05886-0.05813,0.08134 c-0.07786,0.04525-0.20443,0.04525-0.28281,0c-0.03944-0.02277-0.05914-0.05265-0.05905-0.08248l0.00077-17.11984 c-0.00008,0.02983,0.01961,0.05971,0.05905,0.08248c0.07837,0.04525,0.20494,0.04525,0.28281,0 C15.803,28.13213,15.82236,28.10273,15.82245,28.07327z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DDE4E7",
    d: "M15.7634,27.9908c0.07837,0.04525,0.07878,0.11856,0.00092,0.16382 c-0.07786,0.04525-0.20443,0.04525-0.28281,0c-0.07837-0.04525-0.07879-0.11856-0.00093-0.16381 S15.68502,27.94555,15.7634,27.9908z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B0B8BC",
    d: "M16.08517,28.01688l-0.00178,0.11427c-0.00019,0.06807-0.04495,0.13603-0.13435,0.18799 c-0.17996,0.10458-0.47248,0.10457-0.65361,0c-0.09115-0.05263-0.13667-0.12168-0.13648-0.19062l0.00178-0.11427 c-0.00019,0.06894,0.04533,0.13799,0.13648,0.19062c0.18113,0.10458,0.47365,0.10458,0.65361,0 C16.04023,28.15292,16.08498,28.08495,16.08517,28.01688z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DDE4E7",
    d: "M15.9487,27.82627c0.18113,0.10458,0.18208,0.27402,0.00212,0.3786 c-0.17996,0.10458-0.47248,0.10457-0.65361,0c-0.18113-0.10458-0.1821-0.27401-0.00214-0.37859 C15.47504,27.7217,15.76757,27.72169,15.9487,27.82627z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainer);
export default __webpack_public_path__ + "static/media/container.b7c4677212cc1f19dc5dc9fd5cc416cd.svg";
export { ForwardRef as ReactComponent };